<template>
  <div class="card card-custom">
    <div v-if="!noHeader" class="card-header">
      <div class="card-title">
        <span v-if="icon" class="card-icon">
          <i class="text-primary" :class="icon"></i>
        </span>
        <h3 class="card-label">{{ title }}</h3>
      </div>
      <div v-if="hayToolbar" class="card-toolbar">
        <slot name="toolbar"></slot>
      </div>
    </div>
    <div class="card-body" :class="bodyClass">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    icon: {
      type: String,
      default: null,
    },
    bodyClass: {
      type: String,
    },
    noHeader: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hayToolbar() {
      return !!this.$slots.toolbar;
    },
  },
};
</script>

<style></style>
